<template>
  <b-container fluid>
    <!-- Navegação de ano com Button Group -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5>Gráficos Operacionais</h5>
      <div class="btn-group" role="group" aria-label="Navegação de Ano">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="changeYear(-1)"
        >
          Anterior
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary disabled"
        >
          {{ selectedYear }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="changeYear(1)"
        >
          Próximo
        </button>
      </div>
    </div>

    <!-- Gráficos no mesmo layout de antes -->
    <div class="row mb-4">
      <div v-if="permiteGrafico('classificacao-mensal')" class="col-12 col-md-6 mb-4">
          <div class="chart-container">
            <ProspeccaoChart :data-inicio="dataInicio" :data-fim="dataFim" />
          </div>
      </div>
      <div v-if="permiteGrafico('classificacao-anual')" class="col-12 col-md-6 mb-4">
          <div class="chart-container">
            <ProspeccaoPie   :data-inicio="dataInicio" :data-fim="dataFim" />
          </div>
      </div>
    </div>

    <!-- Nova linha com os 2 gráficos adicionais -->
    <div class="row mb-4">
      <div v-if="permiteGrafico('prospeccao-mensal')" class="col-12 col-md-6 mb-4">
        <ProspeccaoMatricChart
          :data-inicio="dataInicio"
          :data-fim="dataFim"
        />
      </div>
      <div v-if="permiteGrafico('matriculas-anual')" class="col-12 col-md-6 mb-4">
        <MatriculasAnualPie
          :data-inicio="dataInicio"
          :data-fim="dataFim"
        />
      </div>
    </div>

    <p v-if="!(permiteGrafico('classificacao-mensal') || permiteGrafico('classificacao-anual') || permiteGrafico('prospeccao-mensal') || permiteGrafico('matriculas-anual'))" class="text-muted">Nenhum gráfico autorizado neste grupo.</p>
  </b-container>
</template>

<script>
import { relatoriosAccess } from '@/utils/relatoriosAccess'
import { BContainer } from 'bootstrap-vue-next'
import ProspeccaoChart from '@/components/Gestao/Graficos/Operacionais/ProspeccaoChart.vue'
import ProspeccaoPie   from '@/components/Gestao/Graficos/Operacionais/ProspeccaoPie.vue'
import ProspeccaoMatricChart   from '@/components/Gestao/Graficos/Operacionais/ProspeccaoMatricChart.vue'
import MatriculasAnualPie   from '@/components/Gestao/Graficos/Operacionais/MatriculasAnualPie.vue'

export default {
  name: 'OperacionaisView',
  components: { BContainer, ProspeccaoChart, ProspeccaoPie, ProspeccaoMatricChart, MatriculasAnualPie },
  data() {
    return { selectedYear: new Date().getFullYear() }
  },
  computed: {
    dataInicio() { return `${this.selectedYear}-01-01` },
    dataFim()    { return `${this.selectedYear}-12-31` }
  },
  methods: {
    permiteGrafico(key) { return relatoriosAccess(this.$globalState).grafico(key) },
    changeYear(delta) { this.selectedYear += delta },
    resetYear()       { this.selectedYear = new Date().getFullYear() }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 250px;       /* altura fixa em desktop */
  max-height: 400px;
}
@media (max-width: 767px) {
  .chart-container {
    height: 300px;     /* um pouco menor em mobile */
  }
}

.btn-group .btn {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

</style>
